import { I18nString } from '@models/i18n/i18n-string';
import { AdminUser } from './admin-user';
import { BinaryFile } from './binary-file';
import { I18nStringMap } from './i18n/i18n-string-map';
import { User } from './user';

export type TemplateType = 'USER' | 'SYSTEM';


export class Order {
    id: string;
    code: string;
    name: string;
    remarks:string;
    subject: string;
    content: string;
    htmlTemplate:BinaryFile;
    type:TemplateType;
    createdDate: string;
    remoteData: any;
    orderFieldLabels: any;

    productName: string;
    columnIdLabelList: [];
    allDataFromRemote: any;


    constructor() {
        this.content = '';
        this.type = 'USER';
    }

    static search(term: string, item: Order) {
        term = term.toLocaleLowerCase();
        return  item.name.toLocaleLowerCase().indexOf(term) > -1;
    }
}
 

export class  OrderSearchingCriteria{
    orderId: string;   
    templateCode: string;
    fromDate: string;
    searchType: string = "LIST_SEARCHING";
}
